"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertDocumentQueueSchema = exports.InsertSecurityCodeQueueSchema = exports.MessageModelSchema = void 0;
const zod_1 = require("zod");
const token_1 = require("../misc/token");
const token_2 = require("../model/token");
exports.MessageModelSchema = {
    auth: zod_1.z.string(),
    scope: zod_1.z.string().optional(),
    type: zod_1.z.string().optional(),
    createdAt: zod_1.z.string(),
    scheduleRepetition: zod_1.z.number()
};
exports.InsertSecurityCodeQueueSchema = zod_1.z.object({
    auth: zod_1.z.string(),
    scope: zod_1.z.literal("aglive"),
    externalIds: zod_1.z.tuple([
        token_1.ExternalIdsSchema.pick({ agliveToken: true, timestamp: true }).required(),
    ]),
    userId: zod_1.z.string(),
    businessId: zod_1.z.string(),
    type: token_2.securityCodeType,
    details: token_1.ProductSecurityCodeDetailSchema,
    status: zod_1.z.array(zod_1.z.string())
});
exports.InsertDocumentQueueSchema = zod_1.z.object({
    auth: zod_1.z.string(),
    scope: zod_1.z.literal("aglive"),
    externalIds: zod_1.z.tuple([
        token_1.ExternalIdsSchema.pick({ agliveToken: true, timestamp: true }).required(),
    ]),
    userId: zod_1.z.string(),
    docId: zod_1.z.string(),
    type: zod_1.z.literal("code"),
    details: zod_1.z.object({
        used: zod_1.z.literal(false),
        codes: zod_1.z.string().array(),
        product: token_1.ProductSecurityCodeDetailSchema.required()
    }),
});
